import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function PrivacyPolicy() {
  return (
   <>
        <Navbar/>
         <div className='AboutUs-banner'>
        <h3>Privacy Policy</h3>
        {/* <p>Customized ASIC & SOC Solutions with Optimized Cost</p> */}

        </div>
        <div className='terms'>

    <p><strong>Last Updated:</strong> [Insert Date]</p>

    <p>At <strong>Semicave Semiconductor</strong>, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website <a href="https://www.semicave.com">www.semicave.com</a>.</p>

    <h2>1. Information We Collect</h2>
    <p>We may collect personal and non-personal information when you interact with our website, including:</p>
    <ul>
      <li>Name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Company name</li>
      <li>IP address and browser type</li>
      <li>Any information submitted through contact forms or newsletters</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Respond to inquiries or service requests</li>
      <li>Send updates, marketing materials, or newsletters (only if opted in)</li>
      <li>Improve the performance and usability of our website</li>
      <li>Monitor and analyze usage and trends</li>
    </ul>

    <h2>3. Sharing Your Information</h2>
    <p>We do not sell, trade, or rent your personal information to third parties. We may share your data only when:</p>
    <ul>
      <li>Required by law or legal process</li>
      <li>Working with trusted partners who assist us in operating our website or conducting our business (under confidentiality agreements)</li>
    </ul>

    <h2>4. Data Security</h2>
    <p>We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>

    <h2>5. Cookies</h2>
    <p>Our website may use "cookies" to enhance user experience. You can choose to disable cookies through your browser settings, but some parts of the site may not function properly.</p>

    <h2>6. Third-Party Links</h2>
    <p>Our website may contain links to other websites. We are not responsible for the privacy practices or content of third-party websites.</p>

    <h2>7. Your Consent</h2>
    <p>By using our website, you consent to the terms of this Privacy Policy.</p>

    <h2>8. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated "Last Updated" date.</p>

    <h2>9. Contact Us</h2>
    <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>

   
      <strong>Semicave Semiconductor</strong><br/><br/>
      Email: <a href="mailto:insert@email.com">hr@semicave.com</a><br/><br/>
      Phone: <a href="tel:+91XXXXXXXXXX"> +91 99029-78741</a><br/><br/>
      Address: BLOCK 11, Marathahalli - Sarjapur Outer Ring Rd, Kaverappa Layout, Kadubeesanahalli, Kadabeesanahalli, Bengaluru, Karnataka 560103
 
 
        </div>
        <Footer/>
    </>
  )
}

export default PrivacyPolicy